const ICON_SHAPE_SELECTOR =
	'path, circle, rect, polygon, polyline, ellipse, line, g, use';
const ACCENT_COLOR = '#665166';
const WHITE_COLOR = '#ffffff';

function normalizeSvg(svg) {
	svg.querySelectorAll('style').forEach((style) => style.remove());

	svg.querySelectorAll(ICON_SHAPE_SELECTOR).forEach((shape) => {
		const fill = shape.getAttribute('fill');
		if (!fill || fill.toLowerCase() !== 'none') {
			shape.setAttribute('fill', 'currentColor');
		}

		const stroke = shape.getAttribute('stroke');
		if (stroke && stroke.toLowerCase() !== 'none') {
			shape.setAttribute('stroke', 'currentColor');
		}

		shape.style.removeProperty('fill');
		shape.style.removeProperty('stroke');
	});

	svg.style.removeProperty('fill');
	svg.style.removeProperty('stroke');
	svg.removeAttribute('fill');
	svg.setAttribute('fill', 'currentColor');
}

export function normalizeThemeIcons(container = document) {
	container
		.querySelectorAll(
			'.hero-form-radio-label svg, .product-overview-radio-label svg',
		)
		.forEach(normalizeSvg);
}

function syncThemeIconColor(label, isCheckedWhite = true) {
	const field = label.querySelector('input');
	if (!field) {
		return;
	}

	const isAccentState = (field.checked ^ !isCheckedWhite) === 1;
	const iconColor = isAccentState ? ACCENT_COLOR : WHITE_COLOR;

	label.style.color = iconColor;
	label
		.querySelectorAll('.theme-icon-wrap, .hero-icon, .hero-icon-mask')
		.forEach((wrap) => {
			wrap.style.color = iconColor;
		});
}

export function syncAllThemeIconColors(
	container = document,
	isCheckedWhite = true,
) {
	container.querySelectorAll('.hero-form-radio-label').forEach((label) => {
		syncThemeIconColor(label, isCheckedWhite);
	});
}

function wrapLegacyHeroIconImages(container = document) {
	container
		.querySelectorAll('.hero-form-radio-label img.hero-category-icon')
		.forEach((img) => {
			if (
				img.closest('.theme-icon-wrap') ||
				img.dataset.themeIconFetch !== undefined
			) {
				return;
			}

			const wrap = document.createElement('span');
			wrap.className =
				'theme-icon-wrap shrink-0 inline-flex items-center justify-center';
			wrap.style.width = `${img.width || 28}px`;
			wrap.style.height = `${img.height || 24}px`;
			img.dataset.themeIconFetch = '';
			img.parentElement?.insertBefore(wrap, img);
			wrap.appendChild(img);
		});
}

async function inlineFetchedHeroIcons(container = document) {
	const images = container.querySelectorAll(
		'.hero-form-radio-label img[data-theme-icon-fetch], .hero-form-radio-label img.hero-category-icon',
	);

	await Promise.all(
		[...images].map(async (img) => {
			if (img.dataset.themeIconProcessed === 'true') {
				return;
			}

			const src = img.getAttribute('src');
			if (!src || !src.toLowerCase().includes('.svg')) {
				return;
			}

			try {
				const response = await fetch(src, { credentials: 'same-origin' });
				if (!response.ok) {
					return;
				}

				const svgMarkup = await response.text();
				const template = document.createElement('template');
				template.innerHTML = svgMarkup.trim();
				const svg = template.content.querySelector('svg');

				if (!svg) {
					return;
				}

				svg.removeAttribute('width');
				svg.removeAttribute('height');
				img.dataset.themeIconProcessed = 'true';
				img.replaceWith(svg);
			} catch {
				img.dataset.themeIconProcessed = 'true';
			}
		}),
	);
}

export function initThemeIcons(container = document) {
	wrapLegacyHeroIconImages(container);

	inlineFetchedHeroIcons(container).finally(() => {
		normalizeThemeIcons(container);
		syncAllThemeIconColors(container, true);
	});
}

// Re-apply when hero category selection changes (hero.js toggles label classes).
document.addEventListener('change', (event) => {
	if (
		event.target instanceof HTMLInputElement &&
		event.target.name === 'animal-type'
	) {
		syncAllThemeIconColors(document, true);
	}
});
